import { MDText } from 'i18n-react';

import flyingMoney from '../../../../../../../client/assets_seller/flying-money.png';
import LocalTexts from '../CompanyStats.texts.json';

import styles from './SaleStats.scss';

const LocalT = new MDText(LocalTexts.saleStats);

export const SaleStats = () => (
  <div className={styles.component}>
    <div className={styles.iconWrapper}>
      <img alt="" className={styles.icon} src={flyingMoney} />
      <img alt="" aria-hidden="true" className={styles.iconShadow} src={flyingMoney} />
      <img alt="" aria-hidden="true" className={styles.iconShadow2} src={flyingMoney} />
      <img alt="" aria-hidden="true" className={styles.iconShadow3} src={flyingMoney} />
    </div>
    <div className={styles.details}>
      <p data-thc-style-override className={styles.heading}>{LocalT.translate('every2Minutes')}</p>
      <p data-thc-style-override className={styles.message}>{LocalT.translate('aCarIsSold')}</p>
    </div>
  </div>
);
